var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import styled from "styled-components";
import { AAVEIcon, CompoundIcon, DDEXIcon, DYDXIcon, OasisIcon, } from "../../../assets/icons/defiApp";
import Logo from "../../../assets/icons/logo";
import { getAssets } from "../../../constants/constants";
import { BaseText, Title } from "../../../designSystem";
import colors from "../../../designSystem/colors";
import theme from "../../../designSystem/theme";
import { useLatestAPY } from "../../../hooks/useAirtableData";
import useAssetsYield from "../../../hooks/useAssetsYield";
import useTextAnimation from "../../../hooks/useTextAnimation";
import { getAssetDisplay } from "../../../utils/asset";
import { productCopies } from "../productCopies";
var YieldComparisonCard = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  border: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  padding: 8px;\n  margin-top: 8px;\n"], ["\n  display: flex;\n  width: 100%;\n  border: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  padding: 8px;\n  margin-top: 8px;\n"])), function (props) { return props.border; }, theme.border.radius, function (props) { return props.background; });
var YieldComparisonTitle = styled(BaseText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", "A3;\n  width: 100%;\n  font-size: 12px;\n  margin-top: 24px;\n\n  &:first-child {\n    margin-top: 14px;\n  }\n"], ["\n  color: ", "A3;\n  width: 100%;\n  font-size: 12px;\n  margin-top: 24px;\n\n  &:first-child {\n    margin-top: 14px;\n  }\n"])), colors.primaryText);
var YieldComparisonText = styled(Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 24px;\n  margin-left: 8px;\n"], ["\n  font-size: 14px;\n  line-height: 24px;\n  margin-left: 8px;\n"])));
var YieldComparisonAPR = styled(YieldComparisonText)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var YieldComparison = function (_a) {
    var vault = _a.vault, _b = _a.config, config = _b === void 0 ? {
        background: "#252322",
        border: theme.border.width + " " + theme.border.style + " " + colors.border,
    } : _b;
    var asset = getAssets(vault);
    var yieldInfos = useAssetsYield(asset);
    var latestAPY = useLatestAPY(vault);
    var loadingText = useTextAnimation(!latestAPY.fetched);
    var perfStr = latestAPY.fetched
        ? latestAPY.res.toFixed(2) + "%"
        : loadingText;
    var renderProtocolLogo = useCallback(function (protocol) {
        switch (protocol) {
            case "aave":
                return _jsx(AAVEIcon, { height: "24", width: "24" }, void 0);
            case "compound":
                return _jsx(CompoundIcon, { height: "24", width: "24" }, void 0);
            case "ddex":
                return _jsx(DDEXIcon, { height: "24", width: "24" }, void 0);
            case "dydx":
                return (_jsx(DYDXIcon, { height: "24", width: "24", style: { borderRadius: "100px" } }, void 0));
            case "mcd":
                return _jsx(OasisIcon, { height: "24", width: "24" }, void 0);
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(YieldComparisonTitle, { children: "Current Projected Yield (APY)" }, void 0), _jsxs(YieldComparisonCard, __assign({ background: config.background, border: config.border }, { children: [_jsx(Logo, { height: "24", width: "24" }, void 0), _jsx(YieldComparisonText, { children: productCopies[vault].title }, void 0), _jsx(YieldComparisonAPR, { children: perfStr }, void 0)] }), void 0), _jsxs(YieldComparisonTitle, { children: ["Market ", getAssetDisplay(asset), " Yields (APY)"] }, void 0), yieldInfos
                .slice(0, 3)
                .map(function (_a) {
                var protocol = _a.protocol, apr = _a.apr;
                if (apr < 0.01) {
                    return _jsx(_Fragment, {}, void 0);
                }
                return (_jsxs(YieldComparisonCard, __assign({ background: config.background, border: config.border }, { children: [renderProtocolLogo(protocol), _jsx(YieldComparisonText, { children: protocol }, void 0), _jsx(YieldComparisonAPR, { children: apr.toFixed(2) + "%" }, void 0)] }), protocol));
            })] }, void 0));
};
export default YieldComparison;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=YieldComparison.js.map